/* Cart drawer open/close helpers (extracted from cart-drawer.liquid).
   Kept as globals because the markup + cart-empty-state use inline onclick handlers. */
function closeCartDrawer() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  const drawerInner = cartDrawer.querySelector('.drawer__inner');
  const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');

  if (drawerInner) {
    drawerInner.style.transition = 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
    drawerInner.style.transform = 'translateX(100%)';
  }

  if (overlay) {
    overlay.style.transition = 'opacity 0.3s ease-in-out';
    overlay.style.opacity = '0';
    overlay.style.pointerEvents = 'none';
  }

  cartDrawer.style.transition = 'opacity 0.3s ease-in-out';
  cartDrawer.style.opacity = '0';
  cartDrawer.style.pointerEvents = 'none';

  // Remove scroll lock class (pairs with add in openCartDrawer)
  document.body.classList.remove('overflow-hidden');

  setTimeout(() => {
    cartDrawer.classList.remove('active', 'is-open');
    cartDrawer.style.visibility = 'hidden';
    cartDrawer.style.pointerEvents = '';

    if (overlay) {
      overlay.style.visibility = 'hidden';
      overlay.style.pointerEvents = '';
    }
  }, 300);
}

function handleCartClick(event) {
  if (!event.target.closest('.continue-button')) {
    closeCartDrawer();
  }
}

/* Price summary + freebie list toggles. Vanilla JS (no jQuery dependency) so the
   ₹total caret reliably opens/closes the price summary even if jQuery isn't loaded. */
function toggleEl(el) {
  if (!el) return;
  var hidden = window.getComputedStyle(el).display === 'none';
  el.style.display = hidden ? 'block' : 'none';
}

function priceSummary() {
  toggleEl(document.getElementById('cartSummary'));
  var total = document.querySelector('.cart__ctas .totals__total-value');
  if (total) total.classList.toggle('actSummary');
}

function freebieList() {
  toggleEl(document.getElementById('freebieList'));
}
